import {request,request2} from "@/utils/request";

const qusetionfcuntion = {
    //页面一加载就请求guidcode，根据guidcode再去请求图片验证码
    getguidCode ()  {
        return request({
            method: 'GET',
            url: '/api/user/register/getguidCode'
          })
    },
 //获取图片验证码
 CreateVerificationCode (data)  {
            return request2({
                method: 'GET',
                url: `/VerificationCode/CreateVerificationCode/?${data}`,
                responseType:'arraybuffer'
              })
        },
    //获取省信息
    getSheng (data)  {
        return request({
            method: 'POST',
            url: '/api/user/area/getCity',
            data
          })
    },
    getHospital (data) {  //获取市级ID
        return request({
            method: 'POST',
            url: '/api/user/areaHospital/getCityHospital',
            data
          })
    },
    //点击获取验证码之后，依次是请求下面三个接口，按照顺序请求，最后在发送短信验证码。
    checkUserName (data) {  //检查用户名是否重复   
        return request({
            method: 'POST',
            url: '/api/user/register/checkUserName',
            data
          })
    },
    checkVerifyCode (data) {  //确认验证码

        return request({
            method: 'POST',
            url: '/api/user/register/checkVerifyCode',
            data
          })
    },
    sendSMS (data) {  //发送信息
        return request({
            method: 'POST',
            url: '/api/user/register/sendSmS',
            data
          })
    },
    register (data) {  //发送信息
        return request({
            method: 'POST',
            url: '/api/user/register/register',
            data
          })
    },
 }


 export default qusetionfcuntion;